/* eslint-disable @typescript-eslint/no-explicit-any */
import { TripBookLanguage } from '51trips-frontend-core'

const tripBookLanguageConverter = {
  fromFirestore: (data: any) => {
    if (data) {
      let id: string
      if (typeof data.id === 'string') {
        id = data.id
      } else {
        return undefined
      }

      let languageTag: string
      if (typeof data.languageTag === 'string') {
        languageTag = data.languageTag
      } else {
        return undefined
      }

      let isActive: boolean = false
      if (typeof data.isActive === 'boolean') {
        isActive = data.isActive
      }

      return new TripBookLanguage(id, languageTag, isActive)
    } else {
      return undefined
    }
  }
}

export default tripBookLanguageConverter
